<template>
  <div class="page">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="mediaItem.title.rendered"></ContentHeader>
        <ul>
          <li>Documentation uploaded by: <strong>{{mediaItem.author[0].name}}</strong></li>
          <li>Document type: <strong>{{mediaItem.mime_type}}</strong></li>
          <li><a :href="mediaItem.source_url" :title="'View or download ' + mediaItem.title.rendered" target="_blank" class="btn btn-primary mt-2">View / Download</a></li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      mediaItem: '',
      contentReady: false,
      contentLoadError: ''
    }
  },
  methods: {
    loadContent: function () {
      WordpressRestAPI.getViewContent('media/' + this.$route.params.id + '?_embed')
        .then(response => {
          this.mediaItem = response.data
          if (response.data.author) {
            WordpressRestAPI.getViewContent('users/?include=' + response.data.author)
              .then(response => {
                this.mediaItem.author = response.data
                document.title = this.mediaItem.title.rendered + ' - ThinkTank'
                this.contentReady = true
              })
              .catch(e => {
                this.contentLoadError = 'Oops! We had a problem with loading this media item. Please try again later.'
                console.error(e)
                this.contentReady = true
              })
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this media item. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  created () {
    document.title = 'Uploaded Documentation - ThinkTank'
    this.loadContent()
  },
  watch: {
    '$route' (to, from) {
      this.loadContent()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Media.vue